import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Quiz from './pages/Quiz';
import References from './pages/References';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import CodingChallenge from './pages/CodingChallenge';
import ChallengeResult from './pages/ChallengeResult';
import Interviews from './pages/Interviews';
import GuidedTour from './components/GuidedTour';
import { LanguageProvider } from './contexts/LanguageContext';
import { TourProvider } from './contexts/TourContext';
import About from './pages/About';
import { HelmetProvider } from 'react-helmet-async';
import Admin from './pages/Admin';
import AdminDashboard from './pages/AdminDashboard';
import { Feed } from './components/Feed';
import { AdminFeed } from './components/AdminFeed';
import { ContributorForm } from './components/ContributorForm';
import { ApplicationsManager } from './components/ApplicationsManager';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <TourProvider>
          <Router>
            <div className="flex flex-col min-h-screen">
              <Navbar />
              <main className="flex-grow">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/quiz" element={<Quiz />} />
                  <Route path="/references" element={<References />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/coding-challenge" element={<CodingChallenge />} />
                  <Route path="/challenge-result" element={<ChallengeResult />} />
                  <Route path="/interviews" element={<Interviews />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/admin-lyfy-2024" element={<Admin />} />
                  <Route path="/admin-dashboard" element={<AdminDashboard />} />
                  <Route path="/feed" element={<Feed />} />
                  <Route path="/admin-feed" element={<AdminFeed />} />
                  <Route path="/contribute" element={<ContributorForm />} />
                  <Route path="/admin-applications" element={<ApplicationsManager />} />
                </Routes>
              </main>
              <Footer />
              <GuidedTour />
              <Analytics />
              <SpeedInsights />
            </div>
          </Router>
        </TourProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;